import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * @warn This component is used at the highest level of the app,
 * where CSS variables hasn't been set yet. To avoid loading a css file here,
 * we hardcode this variable
 *
 * @see https://gitlab.com/mindtickle/dsr/dsr-client/-/blob/track/integration/src/federation/root.css
 */
const MT_SPINNER_COLOR = 'rgb(77, 124, 199)';

interface Props {
  fullScreen?: boolean;
}

const MtSpinner: React.FC<Props> = (props: Props): JSX.Element => {
  const { fullScreen } = props;

  const renderSpinner = (): JSX.Element => (
    <CircularProgress
      size={48}
      sx={{ color: MT_SPINNER_COLOR }}
      thickness={3}
    />
  );

  if (!fullScreen) {
    return renderSpinner();
  }

  return (
    <Box height="100%" left="0" position="fixed" top="0" width="100%">
      <Box
        left="50%"
        position="absolute"
        sx={{ transform: 'translate(-50%, -50%)' }}
        top="50%"
      >
        {renderSpinner()}
      </Box>
    </Box>
  );
};

export default MtSpinner;
